

let DataManager = function () {
  if (DataManager.prototype._singletonInstance) {
    return DataManager.prototype._singletonInstance;
  }

  DataManager.prototype._singletonInstance = this;

  // default score object, these values are saved using the sdk
  this.score = { active: 0, high: 0 };

  // default state object, this gets saved to the users account via the sdk api
  this.state = { musicOn: true, soundsOn: true, coinCount: 0, collectables: [] };

  this.firstTimePlaying = true;

  // session memory, these values are not saved across sessions or by the sdk
  this.session = { checkPointScore: 0, lastMapIndex: 0, coinCount: 0, continueAvailable: true, collectableCount: 0, boardsCleared: 0 };

  this.loadData();
};

DataManager.prototype.checkHighScore = function () {
  // console.log('DataManager.checkHighScore');
  //this.debug('DataManager.checkHighScore');
  if (this.score.active > this.score.high) {
    this.score.high = this.score.active;
    //this.apiManager.setHighScore(this.score.high);
  }
};

DataManager.prototype.addPoints = function (points) {
  this.score.active += points;
  // if (this.score.active >= this.achievements.BeeAggressive.hardCodeRequired) {
  //   this.unlockAchievement(this.achievements.BeeAggressive);
  // }
};

DataManager.prototype.setScore = function (points) {
  this.score.active = points;
};

DataManager.prototype.getScore = function () {
  return this.score.active;
};

DataManager.prototype.getHighScore = function () {
  return this.score.high;
};

DataManager.prototype.addCoins = function (coins) {
  this.session.coinCount += coins;
};

DataManager.prototype.setCoins = function (coins) {
  // console.log('DataManager.setCoins');
  this.session.coinCount = coins;
  // this.saveCoins(); // TODO: Turn back on ? No, I think we should only save coins at levels end
};

DataManager.prototype.getCoins = function () {
  return this.session.coinCount;
};

DataManager.prototype.saveCoins = function () {
    this.state.coinCount = this.session.coinCount;
    this.saveData();
};

DataManager.prototype.clearActiveScore = function () {
  this.score.active = 0;
};

DataManager.prototype.setItem = function (key, value) {
  // console.log('DataManager.setItem', key, value);
  this.state[key] = value;
  this.saveData();
  //this.apiManager.setGameState(this.state);
};

DataManager.prototype.getItem = function (key) {
  // console.log('DataManager.getItem', key);
  return this.state[key];
};

DataManager.prototype.setSessionItem = function (key, value) {
  // console.log('DataManager.setSessionItem', key, value);
  this.session[key] = value;
  this.saveData();
};

DataManager.prototype.getSessionItem = function (key) {
  // console.log('DataManager.getSessionItem', key);
  return this.session[key];
};

DataManager.prototype.saveData = function () {
  if(typeof localStorage == 'object'){
    try{
      window.localStorage.setItem("we_bare_bears_boxed_up", JSON.stringify({
        highscore: this.score.high,
        state: this.state,
        firstTimePlaying: this.firstTimePlaying
      }));
    }
    catch(e){
      
    }
  }
  
};

DataManager.prototype.loadData = function () {
  var data = window.localStorage.getItem("we_bare_bears_boxed_up");
  try {
      var t = 0; 
      for(var x in localStorage){ 
          if(localStorage[x].length){
              t += (((localStorage[x].length * 2))); 
          }
          
      } 

      var parsedData = JSON.parse(data);
      this.score.high = parsedData.highscore;
      this.state = parsedData.state;
      this.session.coinCount = this.state.coinCount;
      this.firstTimePlaying = this.state.firstTimePlaying;
  }
  catch(e){

  }
};

export default DataManager;
